module.exports = __webpack_public_path__ + "img/Bodice-Front-B2-Cb-Db-Ec-Gd.d485c224.png";